import React from 'react'

import { DatePicker } from 'antd'
import moment from 'moment'

const { MonthPicker: AntMonthPicker } = DatePicker

interface MonthPickerProps {
  defaultValue?: moment.Moment
  disabledDate?: (current: moment.Moment | null) => boolean
  monthCellContentRender?: (date: moment.Moment, locale: any) => React.ReactNode
  format?: string | string[]
  onChange?: (date: moment.Moment | null, dateString: string) => void
  placeholder?: string
  className?: string
}

const MonthPicker: React.FC<any> = (props) => {
  return <AntMonthPicker {...props} />
}

export default MonthPicker
